/* eslint-disable */
let SearchResultInfoModel = Backbone.Epoxy.Model.extend({
	defaults: {
		show: false
	}
});

export default SearchResultInfoModel